import { getLanguageCode, languageCodeAndCountryMap } from '@helpers/languages';

/* eslint-disable max-len */
export const getLoginOktaTranslation = (isDunsFlow: boolean) => ({
    en: {
        'primaryauth.title':
            'Log in to your Dun & Bradstreet dashboard to access your products',
        'primaryauth.submit': isDunsFlow ? 'Sign In' : 'Log in', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'Email*' : 'Business email address',
        'primaryauth.password.placeholder': isDunsFlow ? 'Password*' : 'Password',
        'errors.E0000004': 'The user name or password you entered does not match our records. Please try again or reset your password using Forgot Password.',
        'error.username.required': isDunsFlow ? 'Please enter Email' : 'Please enter  Business email address',
        'error.password.required': 'Please enter  Password',
        'errors.E0000014': 'Password change failed due to following reason: Invalid Credentials. If you are still not able to set a new password try doing forgot password.',
        'error.auth.lockedOut': 'Your account has been locked for security reasons. Please try again later after 30mins. If you forgot your password you can reset it.',
        help: ' ',
        'password.expired.submit': 'Update',
        'password.expired.title.generic': 'Password Reset',
        'forgot-password': 'Forgot Password',
        remember: 'Remember Me',
        'oform.errorbanner.title': 'We found some errors.Please review the form and make corrections.',
        'oform.error.unexpected': 'There was an unexpected internal error. Please try again.',
        'primaryauth.title.subtext': 'IMPORTANT: If you have not changed your password in the last 180 days you will need to reset your password using Forgot Password below.',
        'password.complexity.length': 'at least {0} characters',
        'password.complexity.lowercase': 'a lowercase letter',
        'password.complexity.uppercase': 'an uppercase letter',
        'password.complexity.number': 'a number',
        'password.complexity.symbol': 'a symbol',
        'password.complexity.history': 'Your password cannot be any of your last {0} passwords',
        'password.complexity.requirements.header': 'Password requirements:',
        'password.complexity.requirements': 'Password requirements: {0}.',
        'password.oldPassword.placeholder': 'Old password',
        'password.newPassword.placeholder': 'New password',
        'password.confirmPassword.placeholder': 'Repeat password',
        'password.error.match': 'New passwords must match',
        'password.enroll.error.match': 'Passwords must match',
        'password.reset': 'Reset Password',
        'password.complexity.minAgeMinutes': 'At least {0} minute(s) must have elapsed since you last changed your password.',
        'password.complexity.minAgeHours': 'At least {0} hour(s) must have elapsed since you last changed your password.',
        'password.complexity.minAgeDays': 'At least {0} day(s) must have elapsed since you last changed your password.',
        'model.validation.field.blank': 'This field cannot be left blank',
        'error.expired.session': 'Your session has expired. Please try to sign in again.',
    },
    cs: {
        'primaryauth.title':
            'Přihlaste se do sekce Přehled a získejte přístup ke svým produktům',
        'primaryauth.submit': isDunsFlow ? 'Přihlásit se' : 'Přihlásit se', // Changes the sign in button
        'primaryauth.username.placeholder': `E-mail${isDunsFlow ? '*' : ''}`,
        'primaryauth.password.placeholder': isDunsFlow ? 'Heslo*' : 'Heslo',
        'errors.E0000004': 'Zadané uživatelské jméno nebo heslo neodpovídá našim záznamům. Zkuste to prosím znovu nebo obnovte Vaše heslo pomocí možnosti Zapomenuté heslo.',
        'error.username.required': isDunsFlow ? 'Prosím vložte e-mail' : 'Prosím vložte pracovní e-mail',
        'error.password.required': 'Prosím vložte heslo',
        'errors.E0000014': 'Změna hesla se nezdařila z následujícího důvodu: neplatné přihlašovací údaje. Pokud stále nejste schopni nastavit nové heslo, použijte funkci Zapomenuté heslo.',
        'error.auth.lockedOut': 'Váš účet byl z bezpečnostních důvodů uzamčen. Prosím zkuste to znovu později. Pokud jste zapomněli heslo, můžete si jej nechat obnovit.',
        help: ' ',
        'password.expired.submit': 'Aktualizovat',
        'password.expired.title.generic': 'Obnovit heslo',
        'forgot-password': 'Zapomenuté heslo?',
        remember: 'Zapamatovat si mě',
        'oform.errorbanner.title': 'Ve formuláři byly nalezeny chyby. Zkontrolujte je prosím a opravte.',
        'oform.error.unexpected': 'Došlo k neočekávané interní chybě. Zkuste to prosím znovu.',
        'primaryauth.title.subtext': 'DŮLEŽITÉ: Pokud jste během posledních 180 dnů nezměnili své heslo, bude potřeba jej obnovit pomocí funkce Zapomenuté heslo.',
        'password.complexity.length': 'alespoň {0} znaků',
        'password.complexity.lowercase': 'malé písmeno',
        'password.complexity.uppercase': 'velké písmeno',
        'password.complexity.number': 'číslo',
        'password.complexity.symbol': 'symbol.',
        'password.complexity.history': 'heslo se nemůže shodovat s žádným z Vašich {0} předchozích hesel.',
        'password.complexity.requirements.header': 'Požadavky na heslo:',
        'password.complexity.requirements': 'Požadavky na heslo: {0}',
        'password.oldPassword.placeholder': 'Staré heslo',
        'password.newPassword.placeholder': 'Nové heslo',
        'password.confirmPassword.placeholder': 'Opakovat heslo',
        'password.error.match': 'Nové heslo se musí shodovat',
        'password.enroll.error.match': 'Hesla se musejí shodovat',
        'password.reset': 'Obnovit heslo',
        'password.complexity.minAgeMinutes': 'Od poslední změny hesla musí uplynout alespoň {0} minut.',
        'password.complexity.minAgeHours': 'Od poslední změny hesla musí uplynout alespoň {0} hodin.',
        'password.complexity.minAgeDays': 'Od poslední změny hesla musí uplynout alespoň {0} dnů.',
        'model.validation.field.blank': 'Toto pole nemůže být prázdné',
        'error.expired.session': 'Vaše připojení expirovalo. Prosím zkuste se přihlásit znovu.',
    },
    de: {
        'primaryauth.title':
            'Melden Sie sich bei Ihrem Dun & Bradstreet Dashboard an, um auf Ihre Produkte zuzugreifen',
        'primaryauth.submit': isDunsFlow ? 'Anmelden' : 'Anmelden', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'E-mail*' : 'Geschäftliche E-Mail Adresse',
        'primaryauth.password.placeholder': isDunsFlow ? 'Passwort*' : 'Passwort',
        'errors.E0000004': 'Der von Ihnen eingegebene Benutzername oder das Passwort stimmt nicht mit unseren Daten überein. Bitte versuchen Sie es erneut oder setzen Sie Ihr Passwort mit Passwort vergessen zurück.',
        'error.username.required': isDunsFlow ? 'Bitte geben Sie eine E-Mail-Adresse ein' : 'Bitte geben Sie eine geschäftliche E-Mail-Adresse ein',
        'error.password.required': 'Bitte geben Sie das Passwort ein',
        'errors.E0000014': 'Die Passwortänderung ist aus folgendem Grund fehlgeschlagen: Ungültige Anmeldedaten. Falls es Ihnen immer noch nicht möglich ist, ein neues Passwort zu erstellen, versuchen Sie es mit der Funktion Passwort vergessen.',
        'error.auth.lockedOut': 'Ihr Konto wurde aus Sicherheitsgründen gesperrt. Bitte versuchen Sie es später erneut. Wenn Sie Ihr Passwort vergessen haben, können Sie es zurücksetzen.',
        help: ' ',
        'password.expired.submit': 'Aktualisieren',
        'password.expired.title.generic': 'Passwort zurücksetzen',
        'forgot-password': 'Passwort vergessen?',
        remember: 'Anmeldedaten speichern',
        'oform.errorbanner.title': 'Wir haben einige Fehler gefunden. Bitte überprüfen Sie das Formular und korrigieren Sie die Eingabe.',
        'oform.error.unexpected': 'Es gab einen unerwarteteten internen Fehler. Bitte versuchen Sie es erneut.',
        'primaryauth.title.subtext': 'WICHTIG: Wenn Sie Ihr Passwort in den letzten 180 Tagen nicht geändert haben, müssen Sie Ihr Passwort mittels Passwort vergessen unten zurücksetzen.',
        'password.complexity.length': 'mindestens {0} Zeichen',
        'password.complexity.lowercase': 'ein Kleinbuchstabe',
        'password.complexity.uppercase': 'ein Grossbuchstabe',
        'password.complexity.number': 'eine Zahl',
        'password.complexity.symbol': 'ein Symbol',
        'password.complexity.history': 'Ihr Passwort darf nicht identisch mit einem Ihrer letzten {0} Passwörter sein.',
        'password.complexity.requirements.header': 'Passwort-Anforderungen:',
        'password.complexity.requirements': 'Passwort-Anforderungen: {0}',
        'password.oldPassword.placeholder': 'Altes Passwort',
        'password.newPassword.placeholder': 'Neues Passwort',
        'password.confirmPassword.placeholder': 'Passwort wiederholen',
        'password.error.match': 'Neue Passwörter müssen übereinstimmen',
        'password.enroll.error.match': 'Passwörter müssen übereinstimmen',
        'password.reset': 'Passwort zurücksetzen',
        'password.complexity.minAgeMinutes': 'Seit der letzten Änderung Ihres Passworts müssen mindestens {0} Minuten vergangen sein.',
        'password.complexity.minAgeHours': 'Seit der letzten Änderung Ihres Passworts müssen mindestens {0} Stunden vergangen sein.',
        'password.complexity.minAgeDays': 'Seit der letzten Änderung Ihres Passworts müssen mindestens {0} Tage vergangen sein.',
        'model.validation.field.blank': 'Dieses Feld darf nicht leer bleiben',
        'error.expired.session': 'Ihre Sitzung ist abgelaufen. Bitte versuchen Sie, sich erneut anzumelden.',
    },
    hu: {
        'primaryauth.title':
            'Lépjen be a Dun & Bradstreet irányítópultba a termékek eléréséhez',
        'primaryauth.submit': isDunsFlow ? 'Bejelentkezés' : 'Bejelentkezés', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'E-mail*' : 'Vállalati e-mail',
        'primaryauth.password.placeholder': isDunsFlow ? 'Jelszó*' : 'Jelszó',
        'errors.E0000004': 'A megadott felhasználónév vagy jelszó nem megfelelő. Próbálja újra, vagy használja az elfelejtett jelszót.',
        'error.username.required': isDunsFlow ? 'Kérjük, adja meg e-mail címét' : 'Kérjük, adja meg munkahelyi e-mail címét',
        'error.password.required': 'Kérjük, adja meg jelszavát',
        'errors.E0000014': 'A jelszó módosítása a következő ok miatt sikertelen: Érvénytelen hitelesítő adatok. Ha továbbra sem tud új jelszót beállítani, próbálja meg a jelszóemlékeztetőt.',
        'error.auth.lockedOut': 'Fiókját biztonsági okokból zároltuk. Próbálja meg később! Amennyiben elfelejtette jelszavát, lehetőség van annak visszaállítására.',
        help: ' ',
        'password.expired.submit': 'Jelszó megváltoztatása',
        'password.expired.title.generic': 'Jelszó visszaállítás',
        'forgot-password': 'Elfelejtette jelszavát?',
        remember: 'Emlékezz rám',
        'oform.errorbanner.title': 'Találtunk néhány hibát. Kérjük, nézze át az űrlapot, és végezze el a javításokat.',
        'oform.error.unexpected': 'Váratlan belső hiba történt. Kérjük, próbálja meg újra.',
        'primaryauth.title.subtext': 'FONTOS: Amennyiben az elmúlt 180 napban nem változtatta meg a jelszavát, az elfelejtett jelszóval vissza tudja állítani.',
        'password.complexity.length': 'legalább {0} karakter',
        'password.complexity.lowercase': 'egy kisbetű',
        'password.complexity.uppercase': 'egy nagybetű',
        'password.complexity.number': 'egy szám',
        'password.complexity.symbol': 'egy szimbólum',
        'password.complexity.history': 'A jelszó nem választható a legutóbbi {0} jelszó közül.',
        'password.complexity.requirements.header': 'Jelszókövetelmények:',
        'password.complexity.requirements': 'Jelszókövetelmények: {0}',
        'password.oldPassword.placeholder': 'Régi jelszó',
        'password.newPassword.placeholder': 'Új jelszó',
        'password.confirmPassword.placeholder': 'Új jelszó ismét',
        'password.error.match': 'Az új jelszavaknak egyezniük kell',
        'password.enroll.error.match': 'A jelszavaknak egyezniük kell',
        'password.reset': 'Jelszó visszaállítása',
        'password.complexity.minAgeMinutes': 'Legalább {0} percnek el kell telnie, mielőtt újból módosíthatná jelszavát',
        'password.complexity.minAgeHours': 'Legalább {0} órának el kell telnie, mielőtt újból módosíthatná jelszavát',
        'password.complexity.minAgeDays': 'Legalább {0} napnak el kell telnie, mielőtt újból módosíthatná jelszavát',
        'model.validation.field.blank': 'Ez a mező nem maradhat üresen',
        'error.expired.session': 'Az Ön munkamenete lejárt. Kérjük, jelentkezzen be újból.',
    },
    pl: {
        'primaryauth.title':
            'Zaloguj się na swój pulpit Dun & Bradstreet, by uzyskać dostęp do Twoich produktów',
        'primaryauth.submit': isDunsFlow ? 'Zaloguj się' : 'Zaloguj się', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'E-mail*' : 'Firmowy adres e-mail',
        'primaryauth.password.placeholder': isDunsFlow ? 'Hasło*' : 'Hasło',
        'errors.E0000004': 'Wprowadzona nazwa użytkownika lub hasło nie pasują do danych w bazie. Spróbuj ponownie później lub zresetuj swoje hasło, korzystając z funkcji Nie pamiętam hasła.',
        'error.username.required': isDunsFlow ? 'Wprowadź adres e-mail' : 'Wprowadź firmowy adres e-mail',
        'error.password.required': 'Proszę wprowadzić hasło',
        'errors.E0000014': 'Zmiana hasła nie powiodła się z następującego powodu: Nieprawidłowe poświadczenia. Jeśli nadal nie możesz ustawić nowego hasła, spróbuj po przez zapomniałem hasła.',
        'error.auth.lockedOut': 'Twoje konto zostało zablokowane z powodów bezpieczeństwa. Spróbuj ponownie później. Jeśli nie pamiętasz swojego hasła, możesz je zresetować.',
        help: ' ',
        'password.expired.submit': 'Aktualizuj',
        'password.expired.title.generic': 'Resetowanie hasła',
        'forgot-password': 'Nie pamiętasz hasła?',
        remember: 'Zapamiętaj mnie',
        'oform.errorbanner.title': 'Znaleźliśmy kilka błędów. Prosimy o zapoznanie się z formularzem i wprowadzenie poprawek.',
        'oform.error.unexpected': 'Wystąpił nieoczekiwany błąd. Proszę spróbuj ponownie.',
        'primaryauth.title.subtext': 'WAŻNE: Jeśli hasło nie zostało zmienione w ciągu ostatnich 180 dni, musisz je zresetować, korzystając z dostępnej poniżej funkcji Nie pamiętam hasła.',
        'password.complexity.length': 'co najmniej {0} znaków',
        'password.complexity.lowercase': 'mała litera',
        'password.complexity.uppercase': 'Wielka litera',
        'password.complexity.number': 'numer',
        'password.complexity.symbol': 'symbol',
        'password.complexity.history': 'Twoje hasło nie może być żadnym z ostatnich {0} haseł.',
        'password.complexity.requirements.header': 'Wymagania dotyczące hasła:',
        'password.complexity.requirements': 'Wymagania dotyczące hasła: {0}',
        'password.oldPassword.placeholder': 'Stare hasło',
        'password.newPassword.placeholder': 'Nowe hasło',
        'password.confirmPassword.placeholder': 'Powtórz hasło',
        'password.error.match': 'Nowe hasła muszą być zgodne',
        'password.enroll.error.match': 'Hasło musi pasować',
        'password.reset': 'Zresetuj hasło',
        'password.complexity.minAgeMinutes': 'Od ostatniej zmiany hasła musi upłynąć co najmniej {0} minut.',
        'password.complexity.minAgeHours': 'Od ostatniej zmiany hasła musi upłynąć co najmniej {0} godzin',
        'password.complexity.minAgeDays': 'Od ostatniej zmiany hasła musi upłynąć co najmniej {0} dni.',
        'model.validation.field.blank': 'To pole nie może pozostać puste',
        'error.expired.session': 'Twoja sesja wygasła. Spróbuj zalogować się ponownie.',
    },
    fr: {
        'primaryauth.title':
            'Log in to your Dun & Bradstreet dashboard to access your products',
        'primaryauth.submit': isDunsFlow ? 'Sign In' : 'Log in', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'Email*' : 'Business email address',
        'primaryauth.password.placeholder': isDunsFlow ? 'Password*' : 'Password',
        'errors.E0000004': 'The user name or password you entered does not match our records. Please try again or reset your password using Forgot Password.',
        'error.username.required': isDunsFlow ? 'Please enter Email' : 'Please enter  Business email address',
        'error.password.required': 'Please enter  Password',
        'errors.E0000014': 'Password change failed due to following reason: Invalid Credentials. If you are still not able to set a new password try doing forgot password.',
        'error.auth.lockedOut': 'Your account has been locked for security reasons. Please try again later after 30mins. If you forgot your password you can reset it.',
        help: ' ',
        'password.expired.submit': 'Update',
        'password.expired.title.generic': 'Password Reset',
        'forgot-password': 'Forgot Password',
        remember: 'Remember Me',
        'oform.errorbanner.title': 'We found some errors.Please review the form and make corrections.',
        'oform.error.unexpected': 'There was an unexpected internal error. Please try again.',
        'primaryauth.title.subtext': 'IMPORTANT: If you have not changed your password in the last 180 days you will need to reset your password using Forgot Password below.',
        'password.complexity.length': 'at least {0} characters',
        'password.complexity.lowercase': 'a lowercase letter',
        'password.complexity.uppercase': 'an uppercase letter',
        'password.complexity.number': 'a number',
        'password.complexity.symbol': 'a symbol',
        'password.complexity.history': 'Your password cannot be any of your last {0} passwords',
        'password.complexity.requirements.header': 'Password requirements:',
        'password.complexity.requirements': 'Password requirements:',
        'password.oldPassword.placeholder': 'Old password',
        'password.newPassword.placeholder': 'New password',
        'password.confirmPassword.placeholder': 'Repeat password',
        'password.error.match': 'New passwords must match',
        'password.enroll.error.match': 'Passwords must match',
        'password.reset': 'Reset Password',
        'password.complexity.minAgeMinutes': 'At least {0} minute(s) must have elapsed since you last changed your password.',
        'password.complexity.minAgeHours': 'At least {0} hour(s) must have elapsed since you last changed your password.',
        'password.complexity.minAgeDays': 'At least {0} day(s) must have elapsed since you last changed your password.',
        'model.validation.field.blank': 'This field cannot be left blank',
        'error.expired.session': 'Your session has expired. Please try to sign in again.',
    },
    sl: {
        'primaryauth.title':
            'Za dostop do svojih izdelkov se prijavite na nadzorno ploščo Dun & Bradstreet',
        'primaryauth.submit': isDunsFlow ? 'Vpiši se' : 'Vpiši se', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'E-naslov*' : 'E-poštni naslov podjetja',
        'primaryauth.password.placeholder': isDunsFlow ? 'Geslo*' : 'Geslo',
        'errors.E0000004': 'Vneseno uporabniško ime ali geslo se ne ujema s podatki v bazi. Poskusite znova pozneje ali ponastavite geslo s funkcijo Pozabljeno geslo.',
        'error.username.required': isDunsFlow ? 'Vnesite e-naslov' : 'Vnesite poslovni e-poštni naslov',
        'error.password.required': 'Prosim vnesite geslo',
        'errors.E0000014': 'Sprememba gesla ni uspela zaradi naslednjega razloga: Neveljavne poverilnice. Če še vedno ne morete nastaviti novega gesla, poskusite uporabiti možnost pozabljeno geslo.',
        'error.auth.lockedOut': 'Vaš račun je bil blokiran iz varnostnih razlogov. Prosim poskusite kasneje. Če se ne spomnite gesla, ga lahko ponastavite.',
        help: ' ',
        'password.expired.submit': 'Nadgradnja',
        'password.expired.title.generic': 'Resetiranje gesla',
        'forgot-password': 'Ne spomnite se gesla',
        remember: 'Zapomni si me',
        'oform.errorbanner.title': 'Našli smo nekaj napak. Prosimo preglejte obrazec in ga popravite.',
        'oform.error.unexpected': 'Prišlo je do nepričakovane notranje napake. Prosim poskusite ponovno.',
        'primaryauth.title.subtext': 'POMEMBNO: Če vaše geslo ni bilo spremenjeno v zadnjih 180 dneh, ga morate ponastaviti s spodnjo funkcijo Pozabljeno geslo.',
        'password.complexity.length': 'vsaj {0} znakov',
        'password.complexity.lowercase': 'mala črka',
        'password.complexity.uppercase': 'velika črka',
        'password.complexity.number': 'številka',
        'password.complexity.symbol': 'simbol',
        'password.complexity.history': 'Vaše geslo ne sme biti nobeno od zadnjih {0} gesel.',
        'password.complexity.requirements.header': 'Zahteve za geslo:',
        'password.complexity.requirements': 'Zahteve za geslo:',
        'password.oldPassword.placeholder': 'Staro geslo',
        'password.newPassword.placeholder': 'Novo geslo',
        'password.confirmPassword.placeholder': 'Ponovite geslo',
        'password.error.match': 'Novo geslo se mora ujemati',
        'password.enroll.error.match': 'Gesli se morata ujemati',
        'password.reset': 'Ponastavitev gesla',
        'password.complexity.minAgeMinutes': 'Od zadnje spremembe gesla mora preteči vsaj {0} minut.',
        'password.complexity.minAgeHours': 'Od zadnje spremembe gesla mora preteči vsaj {0} ur',
        'password.complexity.minAgeDays': 'Od zadnje spremembe gesla mora preteči najmanj {0} dni.',
        'model.validation.field.blank': 'To polje ne sme biti prazno',
        'error.expired.session': 'Vaša seja je potekla. Poskusite se ponovno prijaviti.',
    },
    sv: {
        'primaryauth.title':
            'Logga in på din Dun & Bradstreet-instrumentpanel för att komma åt dina produkter',
        'primaryauth.submit': isDunsFlow ? 'Logga in' : 'Logga in', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'E-post*' : 'Företagets e-postadress',
        'primaryauth.password.placeholder': isDunsFlow ? 'Lösenord*' : 'Lösenord',
        'errors.E0000004': 'Användarnamnet eller lösenordet du angav stämmer inte överens med våra uppgifter. Försök igen eller återställ ditt lösenord med Glömt lösenord.',
        'error.username.required': isDunsFlow ? 'Ange e-post' : 'Ange företagets e-postadress',
        'error.password.required': 'Ange lösenord',
        'errors.E0000014': "Lösenordsändringen misslyckades av följande anledning: Ogiltiga inloggningsuppgifter. Om du fortfarande inte kan ange ett nytt lösenord, försök 'Glömt lösenordet'.",
        'error.auth.lockedOut': 'Ditt konto har låsts av säkerhetsskäl. Vänligen försök igen senare. Om du har glömt ditt lösenord kan du återställa det.',
        help: ' ',
        'password.expired.submit': 'Uppdatering',
        'password.expired.title.generic': 'Återställ lösenord',
        'forgot-password': 'Glömt lösenord',
        remember: 'Kom ihåg mig',
        'oform.errorbanner.title': 'Vi hittade några fel. Vänligen granska formuläret och gör korrigeringar.',
        'oform.error.unexpected': 'Det uppstod ett oväntat internt fel. Var god försök igen.',
        'primaryauth.title.subtext': 'VIKTIGT: Om du inte har ändrat ditt lösenord under de senaste 180 dagarna måste du återställa ditt lösenord med Glömt Lösenord nedan.',
        'password.complexity.length': 'minst {0} tecken',
        'password.complexity.lowercase': 'en gemen',
        'password.complexity.uppercase': 'en versal',
        'password.complexity.number': 'ett nummer',
        'password.complexity.symbol': 'en symbol',
        'password.complexity.history': 'Ditt lösenord kan inte vara något av dina senaste {0} lösenord.',
        'password.complexity.requirements.header': 'Lösenordskrav:',
        'password.complexity.requirements': 'Lösenordskrav: {0}.',
        'password.oldPassword.placeholder': 'Gammalt lösenord',
        'password.newPassword.placeholder': 'Nytt lösenord',
        'password.confirmPassword.placeholder': 'Upprepa lösenordet ',
        'password.error.match': 'Nya lösenorden måste stämma ',
        'password.enroll.error.match': 'Lösenorden måste stämma',
        'password.reset': 'Återställ lösenord',
        'password.complexity.minAgeMinutes': 'Minst {0} minuter måste ha gått sedan du senast ändrade ditt lösenord.',
        'password.complexity.minAgeHours': 'Minst {0} timmar måste ha gått sedan du senast ändrade ditt lösenord.',
        'password.complexity.minAgeDays': 'Minst {0} dagar måste ha gått sedan du senast ändrade ditt lösenord.',
        'model.validation.field.blank': 'Detta fält kan inte lämnas tomt',
        'error.expired.session': 'Din tid har gått ut. Vängligen försök att logga in igen.',
    },
    da: {
        'primaryauth.title':
            'Log ind på dit Dun & Bradstreet oversigtsbillede for at tilgå dine systemer',
        'primaryauth.submit': isDunsFlow ? 'Log ind' : 'Log ind', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'Email*' : 'Virksomhedens mailadresse',
        'primaryauth.password.placeholder': isDunsFlow ? 'Kodeord*' : 'Kodeord',
        'errors.E0000004': 'Brugernavnet eller dit kodeord, du har indtastet kan ikke genkendes i vores system. Prøv igen eller få ændret dit kode ved brug af Glemt kodeord.',
        'error.username.required': isDunsFlow ? 'Indtast e-mail' : 'Indtast business-e-mailadresse',
        'error.password.required': 'Indtast adgangskode',
        'errors.E0000014': 'Adgangskodeændring mislykkedes af følgende årsag: Ugyldige legitimationsoplysninger. Hvis du stadig ikke er i stand til at indstille en ny adgangskode, prøv at benytte Glemt adgangskode.',
        'error.auth.lockedOut': 'Din konto er blevet låst af sikkerhedsmæssige årsager. Prøv igen senere. Hvis du har glemt dit kodeord, kan du gendanne det.',
        help: ' ',
        'password.expired.submit': 'Opdater',
        'password.expired.title.generic': 'Gendannelse af kodeord',
        'forgot-password': 'Glemt kodeord',
        remember: 'Husk mig',
        'oform.errorbanner.title': 'Vi fandt nogle fejl. Gennemgå venligst formularen og foretag rettelser.',
        'oform.error.unexpected': 'Der opstod en uventet intern fejl. Venligst prøv igen.',
        'primaryauth.title.subtext': 'BEMÆRK: Hvis du ikke har ændret dit kodeord i de sidste 180 dage, er du nødt til at gendanne dit kodeord ved at benytte Glemt kodeord nedenfor.',
        'password.complexity.length': 'mindst {0} tegn',
        'password.complexity.lowercase': 'et lille bogstav',
        'password.complexity.uppercase': 'et stort bogstav',
        'password.complexity.number': 'et nummer',
        'password.complexity.symbol': 'et symbol',
        'password.complexity.history': 'Din adgangskode kan ikke være nogen af dine sidste {0} adgangskoder.',
        'password.complexity.requirements.header': 'Adgangskodekrav:',
        'password.complexity.requirements': 'Adgangskodekrav: {0}.',
        'password.oldPassword.placeholder': 'Gammel adgangskode',
        'password.newPassword.placeholder': 'Ny adgangskode',
        'password.confirmPassword.placeholder': 'Gentag adgangskode',
        'password.error.match': 'Nye adgangskoder skal matche',
        'password.enroll.error.match': 'Adgangskoder skal matche',
        'password.reset': 'Nulstille adgangskode',
        'password.complexity.minAgeMinutes': 'Der skal være gået mindst {0} minutter, siden du sidst ændrede din adgangskode.',
        'password.complexity.minAgeHours': 'Der skal være gået mindst {0} timer, siden du sidst har ændret din adgangskode.',
        'password.complexity.minAgeDays': 'Der skal være gået mindst {0} dage, siden du sidst ændrede din adgangskode.',
        'model.validation.field.blank': 'Dette felt må ikke stå tomt',
        'error.expired.session': 'Din session er udløbet. Prøv at logge ind igen.',
    },
    nn: {
        'primaryauth.title':
            'Logg på Dun & Bradstreet-dashbordet for å få tilgang til produktene dine',
        'primaryauth.submit': isDunsFlow ? 'Logg på' : 'Logg inn', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'E-post*' : 'Foretakets e-postadresse',
        'primaryauth.password.placeholder': isDunsFlow ? 'Passord*' : 'Passord',
        'errors.E0000004': 'Brukernavnet eller passordet du oppga samsvarer ikke med opplysningene våre. Vennligst prøv igjen eller tilbakestill passordet ditt ved å bruke Glemt passord.',
        'error.username.required': isDunsFlow ? 'Skriv inn e-postadresse' : 'Skriv inn bedriftens e-postadresse',
        'error.password.required': 'Skriv inn passord',
        'errors.E0000014': "Passordendring mislyktes på grunn av følgende årsak: Ugyldig legitimasjon. Hvis du fortsatt ikke er i stand til å angi et nytt passord, prøv 'Glemt passord'.",
        'error.auth.lockedOut': 'Kontoen din er blitt låst av sikkerhetsgrunner. Vennligst prøv igjen senere. Hvis du har glemt passordet ditt, kan du tilbakestille det.',
        help: ' ',
        'password.expired.submit': 'Oppdater',
        'password.expired.title.generic': 'Tilbakestill passord',
        'forgot-password': 'Glemt passord',
        remember: 'Husk meg',
        'oform.errorbanner.title': 'Vi fant noen feil. Vennligst se gjennom skjemaet og foreta rettelser.',
        'oform.error.unexpected': 'Det oppstod en uventet intern feil. Vennligst prøv på nytt.',
        'primaryauth.title.subtext': 'OBS! Hvis du ikke har endret passord i løpet av de siste 180 dagene, må du tilbakestille passordet ditt ved å bruke Glemt passord nedenfor.',
        'password.complexity.length': 'minst {0} tegn',
        'password.complexity.lowercase': 'en liten bokstav',
        'password.complexity.uppercase': 'en stor bokstav',
        'password.complexity.number': 'et tall',
        'password.complexity.symbol': 'et symbol',
        'password.complexity.history': 'Passordet ditt kan ikke være noen av de siste 5 passordene dine.',
        'password.complexity.requirements.header': 'Passordkrav: ',
        'password.complexity.requirements': 'Passordkrav: {0}.',
        'password.oldPassword.placeholder': 'Gammelt passord',
        'password.newPassword.placeholder': 'Nytt passord',
        'password.confirmPassword.placeholder': 'Gjenta passord',
        'password.error.match': 'Nye passord må være like',
        'password.enroll.error.match': 'Passord må være like',
        'password.reset': 'Tilbakestill passord',
        'password.complexity.minAgeMinutes': 'Det må ha gått minst {0} minutter siden du sist endret passordet ditt.',
        'password.complexity.minAgeHours': 'Det må ha gått minst {0} timer siden du sist endret passordet ditt.',
        'password.complexity.minAgeDays': 'Det må ha gått minst {0} dager siden du sist endret passordet ditt.',
        'model.validation.field.blank': 'Dette feltet kan ikke stå tomt',
        'error.expired.session': 'Økten din har utløpt. Vennligst prøv å logge på igjen.',
    },
    fi: {
        'primaryauth.title':
            'Kirjaudu sisään Dun & Bradstreet Dashboardiin päästäksesi käyttämään tuotteitasi.',
        'primaryauth.submit': isDunsFlow ? 'Kirjaudu sisään' : 'Kirjaudu sisään', // Changes the sign in button
        'primaryauth.username.placeholder': isDunsFlow ? 'Sähköposti*' : 'Yrityksen sähköposti',
        'primaryauth.password.placeholder': isDunsFlow ? 'Salasana*' : 'Salasana',
        'errors.E0000004': 'Syöttämäsi käyttäjätunnus tai salasana ei vastaa tietojamme. Yritä uudelleen tai nollaa salasanasi käyttämällä Unohdin salasanan -toimintoa.',
        'error.username.required': isDunsFlow ? 'Kirjoita sähköposti' : 'Anna yrityksen sähköpostiosoite',
        'error.password.required': 'Anna salasana',
        'errors.E0000014': 'Salasanan vaihto epäonnistui seuraavasta syystä: Virheelliset tunnistetiedot. Jos et vieläkään pysty asettamaan uutta salasanaa, kokeile unohtunut salasana -toimintoa.',
        'error.auth.lockedOut': 'Tilisi on lukittu turvallisuussyistä. Kokeile uudestaan myöhemmin. Jos unohdit salasanasi voit palauttaa sen.',
        help: ' ',
        'password.expired.submit': 'Päivitä',
        'password.expired.title.generic': 'Salasanan nollaus',
        'forgot-password': 'Unohdin salasanan',
        remember: 'Muista minut',
        'oform.errorbanner.title': 'Löysimme joitain virheitä. Tarkista lomake ja tee korjaukset.',
        'oform.error.unexpected': 'Tapahtui odottamaton sisäinen virhe. Yritä uudelleen.',
        'primaryauth.title.subtext': 'TÄRKEÄÄ: Jos et ole vaihtanut salasanaasi viimeisen 180 päivän aikana, sinun on palautettava salasanasi käyttämällä alla olevaa Unohdin salasanan -linkkiä.',
        'password.complexity.length': 'vähintään {0} merkkiä',
        'password.complexity.lowercase': 'pieni kirjain',
        'password.complexity.uppercase': 'iso kirjain',
        'password.complexity.number': 'numero',
        'password.complexity.symbol': 'symboli',
        'password.complexity.history': 'Salasanasi ei voi olla mikään viidestä viimeisestä salasanastasi.',
        'password.complexity.requirements.header': 'Salasanavaatimukset:',
        'password.complexity.requirements': 'Salasanavaatimukset: {0}.',
        'password.oldPassword.placeholder': 'Vanha salasana',
        'password.newPassword.placeholder': 'Uusi salasana',
        'password.confirmPassword.placeholder': 'Toista salasana',
        'password.error.match': 'Uusien salasanojen on oltava samat',
        'password.enroll.error.match': 'Salasanojen täytyy täsmätä',
        'password.reset': 'Nollaa salasana',
        'password.complexity.minAgeMinutes': 'Vähintään {0} minuuttia on kulunut siitä, kun viimeksi vaihdoit salasanasi.',
        'password.complexity.minAgeHours': 'Vähintään {0} tuntia on kulunut siitä, kun viimeksi vaihdoit salasanasi',
        'password.complexity.minAgeDays': 'Vähintään {0} päivää on kulunut siitä, kun viimeksi vaihdoit salasanasi.',
        'model.validation.field.blank': 'Tätä kenttää ei voi jättää tyhjäksi',
        'error.expired.session': 'Istuntosi on vanhentunut. Yritä kirjautua sisään uudelleen.',
    }
});

export const getOktaTranslationObj = () => {
    const loginOktaTranslationObj = getLoginOktaTranslation(false);
    const language = getLanguageCode();
    const language_code_selected = languageCodeAndCountryMap[language];
    const translationObj = loginOktaTranslationObj[language_code_selected];
    return translationObj;
};
